import React, { useState } from "react";
import { Button, Grid, makeStyles, CircularProgress } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import CustomTextField from "../../../common-components/CustomTextField";
import AuthWrapper from "../authWrapper";
import { validateOtpAPI } from "../../../api/admin-api";
import { useDispatch, useSelector } from "react-redux";
import { setForgotPasswordAccessToken } from "../../../reducers/forgot-password-reducer";
import ActionMessages from "../../../common-components/ActionMessages";

const useStyles = makeStyles((theme) => ({
  fullPageWrapper: {
    height: "100vh",
    backgroundColor: "#fafafa",
    position: "relative",
  },
  formWrapper: {
    margin: "0 28% 0 30%",
    width: "38%",
    height: "300px !important",
    position: "absolute !important",
    top: "20% !important",
  },
  welcomeWrapper: {
    padding: theme.spacing(4),
    background: "#ffffff",
    borderRadius: 8,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  },
  welcomeHead: {
    fontSize: 24,
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    textAlign: "center",
  },
  loginNote: {
    fontSize: 16,
    marginBottom: theme.spacing(3),
    textAlign: "center",
  },
  fieldStyle: {
    width: "60%",
    margin: "8px auto",
  },
  loginBtn: {
    textTransform: "none",
    borderRadius: theme.spacing(3),
    background: "#0176D3 !important",
    fontWeight: 500,
    width: "60%",
    marginTop: theme.spacing(4),
    padding: "12px 0 !important",
  },
  dangerText: {
    color: "red",
  },
  loadingText: {
    textAlign: "center",
    marginTop: theme.spacing(2),
    color: "#555",
  },
}));

function OTPValidate() {
  const forgotPassEmail = useSelector(
    (state) => state.forgotPasswordReducer.email
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();

  // Checking if the email exist in the store
  if (!forgotPassEmail) history.push("/emailverify");

  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [loading, setLoading] = useState(false);

  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [isErrOpen, setIsErrOpen] = useState(false);

  const errToggler = () => setIsErrOpen((prev) => !prev);

  const handleChange = (event) => {
    const onlyNums = event.target.value.replace(/[^0-9]/g, "");
    setOtp(onlyNums);

    if (!onlyNums) {
      setOtpError("OTP is required");
    } else if (onlyNums.length < 6) {
      setOtpError("Please enter a valid 6-digit OTP");
    } else {
      setOtpError("");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!otp) {
      setOtpError("OTP is required");
      return;
    } else if (otp.length < 6) {
      setOtpError("Please enter a valid 6-digit OTP");
      return;
    }

    try {
      setLoading(true);

      const res = await validateOtpAPI({
        otp: otp,
        email: forgotPassEmail,
      });

      if (res.status !== 200) {
        setMsgType("error");
        setMsgText(res.message || "Invalid OTP");
        setIsErrOpen(true);
        return;
      }
      setTimeout(() => {
        dispatch(setForgotPasswordAccessToken(res.data));
      }, 10);

      setMsgType("success");
      setMsgText("OTP verified successfully!");
      setIsErrOpen(true);

      setTimeout(() => {
        history.push("/changepassword");
      }, 2000);
    } catch (error) {
      setMsgType("error");
      setMsgText("Couldn't verify the OTP. Please try again.");
      setIsErrOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AuthWrapper>
        <Grid item lg={12} className={classes.welcomeHead}>
          <span>OTP Verification</span>
        </Grid>
        <Grid item lg={12} className={classes.loginNote}>
          Please enter the 6-digit OTP sent to your email
        </Grid>
        <Grid item lg={12}>
          <div className={classes.fieldStyle}>
            <CustomTextField
              type="tel"
              selectedValue={otp}
              onChangeItem={handleChange}
              labelVal="Enter OTP"
              id="otp"
              errorValue={!!otpError}
              helperText={
                otpError && (
                  <span className={classes.dangerText}>{otpError}</span>
                )
              }
              isLoginField={true}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: 6,
              }}
            />
          </div>
        </Grid>

        <Grid item lg={12}>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            className={classes.loginBtn}
            type="button"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Validating..." : "Validate OTP"}
          </Button>
        </Grid>

        {loading && (
          <Grid item lg={12} className={classes.loadingText}>
            <CircularProgress size={24} style={{ marginRight: 8 }} />
            Verifying OTP...
          </Grid>
        )}
      </AuthWrapper>

      {isErrOpen && (
        <ActionMessages
          type={msgType}
          isClosed={errToggler}
          message={msgText}
        />
      )}
    </>
  );
}

export default OTPValidate;
